(function () {
  'use strict';

  angular
    .module('app.exposureReportKPI')
    .controller('exposureReportKPICtrl', ['measureService', 'exposureReportKPIService', '$scope','$rootScope','$http','$filter','filterFilter', '$state', 
                                    function (measureService, exposureReportKPIService, $scope, $rootScope, $http, $filter, filterFilter, $state) {

      $scope.$on('refreshDashboard', function(event, args) {
          getDataExposureReportKPI();
      });

      function genKpiExposureReport(KPIs) {
        if (KPIs != null) {
          if(KPIs[0] != null) {
            KPIs[0].value = KPIs[0].value;
          } 

          if(KPIs[1] != null) {
            KPIs[1].value = KPIs[1].value;
          } 

          if(KPIs[2] != null) {
            KPIs[2].value = KPIs[2].value;
          } 

          if(KPIs[3] != null) {
            KPIs[3].value = KPIs[3].value;
          } 
          $scope.mentionsKPIs = KPIs;
        }     
      }

      function getDataExposureReportKPI() {
        var params = $rootScope.saveParams;
        if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
          return;
        }
        params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;
        
        getExposureKPI(params);
      }

      function getExposureKPI(params) {
        exposureReportKPIService.getExposureKPI(params)
          .then(function (response) {
            genKpiExposureReport(response.mentionsKPIs.KPIs);
          })
          .catch(function (msg) {
            $scope.mentionsKPIs = [
                        {name: "ENGAGEMENTS"},
                        {name: "MENTIONS"},
                        {name: "POSTS"},
                        {name: "INFLUENCERS"}
                    ];
          })
          .finally(function () {
            $rootScope.$broadcast('sectionLoaded');
          });
      }

      // first initiating
      getDataExposureReportKPI();
      
    }]);

})();